/**
 * @generated SignedSource<<f2e02c700e242d205ace7b3d870472c8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MeetingRecordingClipVisibility = "PRIVATE" | "PUBLIC" | "WORKSPACE";
export type ClipTrimmer_VisibilityChangeMutation$variables = {
  clipId: string;
  visibility: MeetingRecordingClipVisibility;
};
export type ClipTrimmer_VisibilityChangeMutation$data = {
  readonly updateClipVisibility: {
    readonly clip: {
      readonly id: string;
      readonly visibility: MeetingRecordingClipVisibility;
    };
  } | null;
};
export type ClipTrimmer_VisibilityChangeMutation$rawResponse = {
  readonly updateClipVisibility: {
    readonly clip: {
      readonly id: string;
      readonly visibility: MeetingRecordingClipVisibility;
    };
  } | null;
};
export type ClipTrimmer_VisibilityChangeMutation = {
  rawResponse: ClipTrimmer_VisibilityChangeMutation$rawResponse;
  response: ClipTrimmer_VisibilityChangeMutation$data;
  variables: ClipTrimmer_VisibilityChangeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "clipId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "visibility"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "clipId",
        "variableName": "clipId"
      },
      {
        "kind": "Variable",
        "name": "visibility",
        "variableName": "visibility"
      }
    ],
    "concreteType": "UpdateClipVisibility",
    "kind": "LinkedField",
    "name": "updateClipVisibility",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MeetingRecordingClip",
        "kind": "LinkedField",
        "name": "clip",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "visibility",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ClipTrimmer_VisibilityChangeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ClipTrimmer_VisibilityChangeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9aec01fc91258a17b172a2c92257a6db",
    "id": null,
    "metadata": {},
    "name": "ClipTrimmer_VisibilityChangeMutation",
    "operationKind": "mutation",
    "text": "mutation ClipTrimmer_VisibilityChangeMutation(\n  $clipId: ID!\n  $visibility: MeetingRecordingClipVisibility!\n) {\n  updateClipVisibility(clipId: $clipId, visibility: $visibility) {\n    clip {\n      id\n      visibility\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "799baa9b4eb77c9a9fed82741dd21510";

export default node;
